import { module as m } from 'modujs';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.link = '';
        this.theme = null;

        // EVENTS
        this.events = {
            click: {
                valid: '_valid',
                refuse: '_refuse',
                formCheck: '_formCheck'
            }
        }
    }

    init() {
        this.theme = this.el.dataset.theme;
    }

    show(i__link) {
        this.link = i__link.link;
        gsap.to(this.el, {
            duration: 0.6,
            autoAlpha: 1,
            ease: 'power4.out'
        });
    }

    _formCheck(event) {
        event.preventDefault();
        if(this.$('select')[0].value.trim() !== "") {
            if(this.$('select')[0].value.trim() === "Other countries") {
                this.$('steps')[0].classList.remove('current');
                this.$('steps')[1].classList.add('current');
            } else {
                this.$('steps')[0].classList.remove('current');
                this.$('steps')[2].classList.add('current');
            }
        }
    }

    _valid(event) {
        event.preventDefault();
        gsap.to(this.el, {
            duration: 0.6,
            autoAlpha: 0,
            ease: 'power4.out',
            onComplete: () => {
                this._clean();
            }
        });
        window.open(this.link, '_blank');
    }

    _refuse(event) {
        event.preventDefault();
        this.$('steps')[1].classList.remove('current');
        this.$('steps')[2].classList.add('current');
    }

    _clean() {
        this.$('steps')[0].classList.add('current');
        this.$('steps')[1].classList.remove('current');
        this.$('steps')[2].classList.remove('current');
    }
}
